import { formatLabel } from "@/utils/format-label";
import { Box, Typography } from "@mui/material";
import { GlAccountActionsPopover } from "./gl-actions-popover";
import { formatUnderscoreLabel } from "@/utils/format-underscore-label";

export const getGlAccountColumns = (onEditClick) => [
  {
    accessorKey: "code",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Account Code</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500} fontFamily="monospace">
        {row.original.code ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Account Name</div>,
    cell: ({ row }) => (
      <div>
        <div
          style={{ fontSize: "0.85rem", whiteSpace: "nowrap", fontWeight: 500 }}
        >
          {row.original.name ?? "N/A"}
        </div>
        <div style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 2 }}>
          {row.original.description}
        </div>
      </div>
    ),
  },
  {
    accessorKey: "accountType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Account Type</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatLabel(row.original.accountType) ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "category",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatUnderscoreLabel(row.original.category) ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "normalBalance",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Normal Balance</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatLabel(row.original.normalBalance) ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "isActive",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const isActive = row.original.isActive;
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isActive ? "#ecfdf5" : "#fef2f2",
            color: isActive ? "#065f46" : "#991b1b",
            fontSize: "0.78rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {isActive ? "Active" : "Inactive"}
        </Box>
      );
    },
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <GlAccountActionsPopover
        glAccount={row.original}
        onEditClick={onEditClick}
      />
    ),
  },
];
